function SubmitButton(props) {
    return(
        <button type="submit" className="p-6 w-full align-center flex justify-center rounded-2xl 
        text-white font-semibold disabled:bg-gray-300 bg-[#8570FF]"  
            disabled={props.disabled ? true : false}
            placeholder={props.placeholder}>
            {props.children}
        </button>
    )
}

export default SubmitButton;